var map = {
	"./Logo_transparente.gif": "e4a0",
	"./img/Logo_transparente.gif": "6c06",
	"./img/logoblanco.png": "946c",
	"./logo.png": "cf05",
	"./selectbox-arrow.png": "f303",
	"./styles.css": "a347",
	"./svg/sprite.svg": "3bc6",
	"./svg/sprite/user.svg": "56c3",
	"./svg/user.svg": "4d66",
	"./tailwind.min.css": "fb6b",
	"./test": "ad5a",
	"./test.json": "ad5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";